export default "__VITE_ASSET__CpBuZm7v__"